import * as TYPES from '../types';
import { REDUX_CONSTANT } from '../../constants';

const initialState = {
    isLoading: false
};

export default function getCommonInformation(state = initialState, action) {
    switch (action.type) {
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
}
